module.exports = __webpack_public_path__ + "media/images/covers/top-uk-boarding-schools-poster-7718b3eba2de294c4f23037b604da2d6.jpg";